import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import "./button.css"

const Button = ({ children, url, type, internal, onClick, target }) => {
  if (internal) {
    return (
      <Link to={url} className={`btn ${type}`} onClick={onClick}>
        {children}
      </Link>
    )
  } else {
    return (
      <a href={url} className={`btn ${type}`} onClick={onClick} target={target}>
        {children}
      </a>
    )
  }
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
  type: PropTypes.string,
  internal: PropTypes.bool,
}

Button.defaultProps = {
  url: `#`,
  type: `primary`,
  internal: true,
  target: "_self",
}

export default Button
